module.exports = __webpack_public_path__ + "static/media/IMG_8033.d7370d83.jpg";